import { resetPartnerData } from 'legacy/lut/features/partner/partnerSlice'
import { selectPartnerData } from 'legacy/lut/features/partner/selectors'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback, useEffect } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { IPartner } from 'clickNgo/entities/partner/models'
import { PartnerHelper } from 'onboarding/classes/helpers/PartnerHelper'
import { showError } from 'onboarding/classes/services/notification'
import { partnerThunks } from 'onboarding/features/api/partnerThunks'

export const useGetPartnerData = (partnerId: string = '') => {
  const dispatch = useAppDispatch()
  const { data, status, message } = useSelector(selectPartnerData, shallowEqual)

  const fetchPartner = useCallback(async () => {
    let item: IPartner | null = null
    let error: Error | null = null

    try {
      item = await dispatch(partnerThunks.fetchOneByPartnerId({ partnerId })).unwrap()
    } catch (e: any) {
      error = e
      showError(e.message, { autoHide: false })
    }

    return { item, error }
  }, [dispatch, partnerId])

  const fetchDummyPartner = useCallback(async () => {
    let item: IPartner | null = null
    let error: Error | null = null

    try {
      item = await dispatch(partnerThunks.fetchChangeRequestByPartnerId({ partnerId })).unwrap()
    } catch (e: any) {
      error = e
      showError(e.message, { autoHide: false })
    }

    return { item, error }
  }, [dispatch, partnerId])

  useEffect(() => {
    if (PartnerHelper.isDummyPartnerRequest(partnerId)) {
      fetchDummyPartner()
      return
    }

    if (partnerId === '') {
      dispatch(resetPartnerData)
    }

    if (partnerId) {
      fetchPartner()
    }
  }, [dispatch, fetchPartner, partnerId, fetchDummyPartner])

  return {
    partnerData: data,
    status,
    message,
    fetchPartner,
    fetchDummyPartner,
  }
}
